import React from 'react';
import { connect } from 'redux-bundler-react';

class LegendItem extends React.Component {
  constructor(props){
    super(props);
    const { displayName } = props.layer;
    this.state = {
      displayName: displayName
    }
  }

  render(){
    const { displayName } = this.state;
    return (
      <li className="list-group-item">
        <div className="overflow-ellipsis" title={ displayName }><strong>{ displayName }</strong></div>
        Unable to Generate Legend For this Layer
      </li>
    )
  }
}

export default connect(
  'selectApiRoot',
  LegendItem
);